import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import { cloneDeep, isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { checkArray, customStyles } from '../../../Components/helper';
import Spinner from '../../../Components/LogoSpinner/Spinner';
import { useProductListingState } from './RangePlanProductListingProvider';
import * as ProductListAction from './store/ProductList.action';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

function ProductFieldsModal({ show, toggle, showLoader, selectedIds }) {
  const [selectedFields, setSelectedFields] = useState([]);
  const { t } = useTranslation('common');

  const {
    rangePlanProvider: { productFields, selectedSection },
    setRangePlanProvider,
  } = useProductListingState();
  const dispatch = useDispatch();

  useEffect(() => {
    const checkedField = checkArray(productFields) && productFields.filter((ele) => ele.isCheckedItem);
    setSelectedFields(checkedField);
  }, []);

  const handleInputSelect = (val, id) => {
    const copyState = cloneDeep(selectedFields);
    const index = copyState.findIndex((x) => x._id === id);
    copyState[index].value = val;
    setSelectedFields(copyState);
  };

  const renderField = (eleField, pIndex) => {
    switch (eleField.type) {
      case 'dropdown':
        return (
          <div className="common-react-select">
            <p className="field-name">{eleField.label}</p>
            <Select
              options={eleField.values}
              value={eleField?.value}
              onChange={(e) => handleInputSelect(e, eleField._id)}
              getOptionLabel={(option) => option.keyName}
              getOptionValue={(option) => option._id}
              styles={customStyles}
              placeholder={eleField.keyName}
              className="common-select"
              classNamePrefix="common-select"
            />
          </div>
        );
      case 'text':
        const maxlen = !eleField.textFieldConfig?.isExceedable && eleField.textFieldConfig?.charLimit;
        const isExceedable = eleField.textFieldConfig?.isExceedable;
        const isHightlight = eleField.textFieldConfig?.isHighlightable;
        const shouldHighlight = isExceedable && isHightlight && eleField?.value?.length > eleField.textFieldConfig?.charLimit;

        return (
          <div className="common-input-control">
            <p className="field-name">{eleField.keyName}</p>
            <input
              maxLength={maxlen}
              disabled={!eleField?.textFieldConfig?.isEditable}
              style={shouldHighlight ? { color: 'red' } : {}}
              type="text"
              value={eleField?.value || ''}
              placeholder={eleField.label}
              className="form-control"
              onChange={(e) => handleInputSelect(e.target.value, eleField._id)}
            />
          </div>
        );

      default:
        break;
    }
  };

  const checkFormValid = () => {
    let validCount = 0;
    let isValid = false;
    selectedFields.forEach((element) => {
      if (element.hasOwnProperty('value') && !isEmpty(element.value)) {
        validCount += 1;
      }
    });
    if (validCount === selectedFields.length) {
      isValid = true;
    }

    return isValid;
  };

  const hadleSumbitBulkManual = async () => {
    const isValid = checkFormValid();
    if (isValid) {
      const columns = selectedFields.map((element) => {
        if (element.type === 'dropdown') {
          return {
            colId: element._id,
            valueId: element.value?._id,
            valueText: '',
          };
        }
        if (element.type === 'text') {
          return {
            colId: element._id,
            valueId: null,
            valueText: element.value,
          };
        }
      });
      const customBulkData = {
        devOrderIds: selectedIds,
        type: 'custom-attribute',
        data: columns,
        sectionId: selectedSection?.value,
      };

      const res = await dispatch(ProductListAction.bulkExchangeRateUpdate(customBulkData, t));
      if (res) {
        if (res.code === 200) {
          toggle();
          setRangePlanProvider((prevState) => ({
            ...prevState,
            selectedSection: null,
            productFields: [],
          }));
        }
      }
    } else {
      toasterMsg('All fields are required.', 'danger');
    }
  };

  return (
    <Modal className="common-custom-modal bulk-manual-modal" size="md" show={show} onHide={toggle} backdrop="static">
      <Modal.Header>
        <Modal.Title>{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_FIELDS_MODAL.MODAL_TITLE')}</Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {showLoader ? (
          <Spinner />
        ) : (
          <Row>
            {checkArray(selectedFields) &&
              selectedFields.map((eleField, i) => {
                const keyID = eleField;
                return (
                  <Col key={keyID} md={6}>
                    <FormGroup className="mb-2">{renderField(eleField, i)}</FormGroup>
                  </Col>
                );
              })}
          </Row>
        )}
        <div className="common-model-footer mt-24">
          <button className="btn p-0" type="button" aria-label="Save" onClick={hadleSumbitBulkManual}>
            <span className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ProductFieldsModal;
